import React from 'react'

const Autoplay2 = ({ color = '#323232' }) => {
  return (
    <svg
      version={1.0}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      className="cursor-pointer w-full h-full"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2360 4683 c-274 -22 -709 -161 -806 -259 -68 -68 -82 -154 -39 -241
  30 -59 80 -97 145 -112 57 -13 88 -5 221 52 456 196 935 190 1393 -16 105 -47
  167 -52 231 -19 76 39 115 103 115 192 0 98 -49 157 -180 219 -192 89 -435
  156 -662 180 -90 10 -314 12 -418 4z"
        />
        <path
          d="M973 3956 c-42 -20 -64 -41 -121 -118 -172 -228 -294 -482 -363 -752
  -25 -97 -21 -148 15 -210 78 -133 284 -135 360 -3 14 23 34 80 46 127 52 204
  137 378 282 579 37 51 73 112 79 134 25 94 -22 196 -112 241 -66 33 -118 33
  -186 2z"
        />
        <path
          d="M3953 3955 c-73 -37 -106 -89 -111 -175 -5 -78 4 -98 83 -205 120
  -159 215 -351 269 -540 15 -49 39 -115 54 -145 95 -189 375 -132 390 79 7 96
  -65 326 -169 538 -56 114 -184 313 -250 387 -77 87 -170 109 -266 61z"
        />
        <path
          d="M2246 3430 c-116 -30 -233 -130 -289 -247 l-32 -68 -3 -524 c-2 -339
  1 -542 8 -574 27 -126 111 -232 234 -293 62 -30 88 -37 158 -41 138 -9 166 5
  598 292 206 137 394 269 418 293 53 52 99 148 113 231 18 112 -20 244 -97 337
  -41 51 -778 546 -859 577 -58 22 -191 31 -249 17z m774 -872 c0 -6 -564 -384
  -657 -442 -10 -6 -13 86 -13 443 l0 451 335 -222 c184 -123 335 -226 335 -230z"
        />
        <path
          d="M644 2341 c-44 -11 -100 -47 -122 -79 -11 -15 -83 -169 -162 -342
  -126 -278 -143 -321 -143 -370 -1 -88 46 -161 125 -195 42 -17 124 -20 161 -6
  49 19 100 75 134 149 l34 73 56 -93 c298 -496 788 -857 1346 -993 300 -73 685
  -73 982 1 221 55 497 176 678 297 372 250 651 593 811 997 87 222 115 373 80
  443 -59 118 -189 157 -301 91 -52 -30 -76 -64 -98 -134 -79 -263 -132 -385
  -231 -538 -254 -390 -640 -653 -1104 -754 -91 -19 -134 -22 -330 -22 -197 -1
  -238 2 -330 22 -464 101 -856 371 -1109 761 -22 35 -39 66 -38 68 2 2 37 -11
  77 -28 62 -26 83 -30 132 -27 181 13 259 241 125 366 -13 13 -109 61 -213 108
  -486 220 -492 222 -560 205z"
        />
      </g>
    </svg>
  )
}

export default Autoplay2
